export default __webpack_public_path__ + "static/media/profile4.641bb513.JPG";